import BannerHistory from "@via/pages/account/admin/notification-settings/components/banner-history.tsx";
import CreateBannerForm from "@via/pages/account/admin/notification-settings/components/create-banner-form.tsx";
import EditBannerDrawer from "@via/pages/account/admin/notification-settings/components/edit-banner-drawer.tsx";
import {
  useDeleteBanner,
  useGetBannerHistory,
} from "@via/pages/account/admin/notification-settings/notification-settings.api.tsx";
import { SystemBannerWithCreator } from "common";
import { type JSX, useState } from "react";

const DEFAULT_PAGE_SIZE = 20;

export default function NotificationSettings(): JSX.Element {
  // Pagination state
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  const { data: historyData, isLoading: isLoadingHistory } =
    useGetBannerHistory(page, pageSize);
  const { mutate: deleteBanner, isPending: isDeletingBanner } =
    useDeleteBanner();

  // Edit drawer state
  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);
  const [bannerToEdit, setBannerToEdit] =
    useState<SystemBannerWithCreator | null>(null);

  const handleEditBanner = (banner: SystemBannerWithCreator) => {
    setBannerToEdit(banner);
    setIsEditDrawerOpen(true);
  };

  const handleCloseEditDrawer = () => {
    setIsEditDrawerOpen(false);
    setBannerToEdit(null);
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPage(0); // Reset to first page when page size changes
  };

  return (
    <div className="space-y-5">
      {/* Create Banner Form */}
      <CreateBannerForm />

      {/* Divider */}
      <hr className="border-gray-200" />

      {/* Notification History Section */}
      <BannerHistory
        banners={historyData?.data ?? []}
        total={historyData?.total ?? 0}
        isLoading={isLoadingHistory}
        isDeleting={isDeletingBanner}
        page={page}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        onEdit={handleEditBanner}
        onDelete={id => deleteBanner({ id })}
      />

      {/* Edit Banner Drawer */}
      <EditBannerDrawer
        banner={bannerToEdit}
        isOpen={isEditDrawerOpen}
        onClose={handleCloseEditDrawer}
      />
    </div>
  );
}
